import React, { useState } from "react";
import { Image } from "react-native";
import * as flag from "./flags/flagsIndex";

interface Props {
  isoCode: string;
  size: number;
  style?: any;
}

function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const CountryFlag = ({ isoCode, size, style }: Props) => {
  const [flagError, setFlagError] = useState(false);

  const getFallbackFlagUrl = (iso: string) => {
    return `https://flagcdn.com/w80/${iso.toLowerCase()}.png`;
  };

  const handleError = () => {
    setFlagError(true);
  };

  // This switch case is just there because you can't name variables "in" and "do"
  switch (isoCode.toLowerCase()) {
    case "in":
      return (
        <Image
          source={flag.ind}
          resizeMode="contain"
          style={[{ width: size * 1.6, height: size }, style]}
        />
      );

    case "do":
      return (
        <Image
          source={flag.dom}
          resizeMode="contain"
          style={[{ width: size * 1.6, height: size }, style]}
        />
      );

    case "gb-eng":
    case "gb-nir":
    case "gb-sct":
    case "gb-wls":
      const suffix = capitalizeFirstLetter(isoCode.toLowerCase().split("-")[1]);
      const key = `gb${suffix}`;
      return (
        <Image
          source={(flag as any)[key]}
          resizeMode="contain"
          style={[{ width: size * 1.6, height: size }, style]}
        />
      );

    default:
      return !flagError ? (
        <Image
          source={(flag as any)[isoCode.toLowerCase()]}
          resizeMode="contain"
          style={[{ width: size * 1.6, height: size }, style]}
          onError={handleError}
        />
      ) : (
        <Image
          source={{ uri: getFallbackFlagUrl(isoCode) }}
          resizeMode="contain"
          style={[{ width: size * 1.6, height: size }, style]}
        />
      );
  }
};

export default CountryFlag;
